import React from "react";

import {
  Box,
  Button,
  Typography,
  makeStyles // useMediaQuery,
  // useTheme
} from "@material-ui/core";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

// import useToast from "src/hooks/useToast";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex"
  },
  rootUnder: {
    width: "60%",
    margin: "0 auto"
  },

  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  accordion: {
    width: "50%",
    margin: "0 auto",
    "&.Mui-expanded": {
      margin: "0 auto"
    }
  }
}));
export default function ErrorFallBack({error}) {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const handleClickReloadPage = () => {
    window.location.pathname = "/";
  };
  return (
    <div className={classes.root}>
      <Box mt={6} justifyContent="left" position="fixed" pl={10}>
        <Button color="primary" variant="outlined" onClick={handleClickReloadPage}>
          Back to home
        </Button>
      </Box>
      <div role="alert" className={classes.rootUnder}>
        <Box mt={6} display="flex" justifyContent="center">
          <img alt="Under development" src="/static/images/something-went-wrong.gif" />
        </Box>
        <Accordion
          className={classes.accordion}
          expanded={expanded === "panel1"}
          onChange={handleChange("panel1")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography>Oops! Something went wrong</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <Typography align="center" color="textPrimary">
                Message: {error.message}
              </Typography>
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
}
